import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.js';

import { GiftCatalogCardSkeleton } from '../../../molecules/gift-catalog-card/gift-catalog-card';

export const GiftCatalogCoreSkeleton: React.FC<{
  itemCount?: number;
}> = ({ itemCount = 9 }) => {
  return (
    <>
      <Skeleton height={28} width={180} />

      <div className="grid gap-comfy-sm @md:gap-comfy-lg grid-cols-1 @sm:grid-cols-2 @md:grid-cols-3">
        {Array.from({ length: itemCount }, (_, index) => (
          <GiftCatalogCardSkeleton key={index} />
        ))}
      </div>
    </>
  );
};
